import { Controller } from "@hotwired/stimulus"
import { createRoot } from "react-dom/client"
import BooksIndex from "../components/BooksIndex"

// Mount point for the books#index screen: takes the books rendered by the
// view and hands them to React.
export default class extends Controller {
  static values = { books: Array }

  connect() {
    this.root = createRoot(this.element)
    this.root.render(<BooksIndex books={this.booksValue} />)
  }

  disconnect() {
    this.root?.unmount()
  }
}
